import { useEffect, useState } from "react";
import Login from "./Login";
import Students from "./Students";
import { api } from "./api";

export default function App() {
    const [authed, setAuthed] = useState(null);

    useEffect(() => {
        api.me()
            .then((r) => setAuthed(!!r.authenticated))
            .catch(() => setAuthed(false));
    }, []);

    return (
        <div className="min-h-screen">
            {authed === null ? null : !authed ? (
                <Login onLogin={() => setAuthed(true)} />
            ) : (
                <Students />
            )}
        </div>
    );
}
